module.exports = __webpack_public_path__ + "media/images/spree/frontend/favicon-110f31856e2b71351e69e4f2ca42c1fd.png";